const diyLoanDetailsEventCategory = "DIY_CR";

export const diyLoanCreditReportSubmitted = {
    eventCategory: diyLoanDetailsEventCategory,
    event: "Credit_consent_button_clicked",
    eventAction: "Credit consent button clicked"
};

export const diyLoanCreditMobileErrorSubmitted = {
    eventCategory: diyLoanDetailsEventCategory,
    event: "Credit_mobile_input_confirmed",
    eventAction: "Credit mobile input confirmed"
};
